import {ResolveFn} from "@angular/router";

export const InscriptionResolver: ResolveFn<boolean> = () => {

  return true;
};
